<div [hidden]="!show" id="myModal" class="modal" (click)="onBackgroundClickClose($event)">
    <div class="modal-content">
        <div class="modal-header">
            <span class="close" (click)="onClose()">&times;</span>
            <h2> {{ 'Title.message' | translate }}</h2>
        </div>
        <div class="modal-body" *ngIf="message">
            <div style="text-align: center;"> {{message}}
            </div>
        </div>
        <div class="modal-body" *ngIf="messages">
            <div style="display: flex; justify-content: center !important;">
                <div>

                    <ng-container *ngFor="let item of messages">

                        <div style="text-align: left;">
                            {{item.Value}}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>